import React, { useState, useEffect, useRef } from 'react';
import { gql, useQuery } from '@apollo/client';
import BarraNavegacion from './BarraNavegacion';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const GET_PRODUCTOS = gql`
  query getProductosLegumbre {
    getProductosLegumbre {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;



function GetProductosLegumbre() {
  
  

  const { data, loading, error} = useQuery(GET_PRODUCTOS);



  
 

   

    
 
  if (loading ) return <p>Cargando datos...</p>;
  if (error) return <p>Error al cargar productos</p>;
  

 
const productosOcultos = [
'68553fed71e3c6f0e1c55eeb',
'68b1fb421c805dd5af38ff19',
'68f8c509aeb441842f5a5756',
'68b088be4bb482ce0bd0d796',
'6a222175796533635af30fa8',
'699f7eab72004501c279fdff',
'689fc0d19bd6940623b6c793',
'689fc1089bd6940623b6c795',
'69b00498775425a7ff12edff',
'6811080d91276f0210687331',
'68f8c52aaeb441842f5a5757',
'681e4c40d60dc813f9b63878',
'67bdfd95a994a553246fa2d2',
'673648e881078ca1b0d3b9d5',
'6883b4ddb6700ebb1610f876',
'6998af7ef4335dee5b2f3768',
'6a20952869bb6cad37d3f440',
'6985f5523df7b582d0504210',
'69b6e421904e0fe7789398ff',
'68ea91de313279d8297ee1f0',
'6998b038f4335dee5b2f376b',
'699f7ccd72004501c279fdfb',
'67e6d874f8bb1091753b9cf3',
'6a19a90d70412b8b342e7f7f',
'68caa00b38f326703f88bbe3',
'69cffd1595b868e79e7e54ce',
'6a510baecc077f6a0accb481',
'69aaf2c623108e2b81ba7e05',
'697cd86181ffec503debdad3',
'6a5a86c2844506c2d842dbbe'
];

const getProductos = data.getProductosLegumbre
  .filter(producto => !productosOcultos.includes(producto._id))
  .sort((a, b) => a.nombre.localeCompare(b.nombre));
  return (
    <div>
      <center><h1>Precios transparentes para una mejor experiencia de compra</h1></center>

     <div className="container-fluid p-0">
  <div className="row g-0">

    {getProductos.map((producto) => (
     <div
  key={producto._id}
  className="col-4 col-md-3 col-lg-1 p-0"
>
  <div className="card legumbre-precios">

    <img
      src={producto.imagen}
      alt={producto.nombre}
    />

    <div className="nombre-producto">
      {producto.nombre}
    </div>
    <div className="precio-producto">
  ${
    producto.codigo === "1"
      ? (producto.precio * 1000).toLocaleString()
      : producto.precio.toLocaleString()
  }
</div>

  </div>
</div>
    ))}

  </div>
</div>
    </div>
  );
}

export default GetProductosLegumbre;
